import React from 'react';

const checkbox = (props) => {
  let iconLabel = props.selected ? "check_box" : "check_box_outline_blank";
  iconLabel = props.indeterminate ? "indeterminate_check_box" : iconLabel;

  let iconClass = props.selected ? "font-color-blue" : "font-color-dark";
  iconClass += " material-icons";

  const iconStyle = props.selected ? {
    opacity: 1
  } : {
    opacity: 0.3
  }

  return (
    <i className={iconClass} style={iconStyle}>{iconLabel}</i>
  )
}

export default checkbox;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/basic/CheckBox.js